import React from 'react';
import * as classnames from 'classnames';
import './index.scss';

const ButtonInfo = (props) => {
	const {
		label = '',
		type = 'button',
		className = '',
		onClick = () => { },
		disabled = false
	} = props;

	return (
		<button
			type={type}
			className={classnames(
				'button-info',
				className && className,
				disabled && '-disabled',
			)}
			onClick={onClick}
		>
		{label}
		</button>
	)
}

export default ButtonInfo;